import React from 'react';

import AirportPicker from '../common/AirportPicker';
// import DatePicker from '../common/DatePicker';
import { format, addDays, parseISO } from 'date-fns';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const MulticitySelector = ({ slices, updateSlices, airports, }) => {
  const NOW = new Date();
  const TODAY = parseISO(format(addDays(NOW, 0), 'yyyy-MM-dd'));
  const TODAYSTRING = format(addDays(NOW, 0), 'yyyy-MM-dd');

  const addSlice = (e) => {
    e.preventDefault();

    updateSlices([
      ...slices, {
        id: slices.length + 1,
        departureStation: '',
        destinationStation: '',
        departureDate: TODAY,
      }
    ]);
  };

  const removeSlice = (id) => {
    if (slices.length > 2) {
      updateSlices(
        slices.filter(slice =>
          slice.id !== id
        )
      );
    }
  };

  const updateSlice = (sliceId, update) => {
    const updatedSlices = slices
      .map((slice) => slice.id === sliceId
        ? { ...slice, ...update }
        : slice
      );
    updateSlices(updatedSlices);
  };

  const update = (sliceId, key, value) => updateSlice(sliceId, {
    [key]: value
  });

  const switchDirection = (sliceId) => {
    const updatedSlices = slices
      .map((slice) => slice.id === sliceId
        ? {
          ...slice,
          departureStation: slice.destinationStation,
          destinationStation: slice.departureStation,
        }
        : slice
      );
    updateSlices(updatedSlices);
  };

  return (
    <>
      {
        slices.map(slice => {
          return (
            <div className="airports" key={slice.id}>
              <AirportPicker
                value={slice.departureStation}
                placeholder="أين ستبدأ رحلتك"
                airports={airports}
                onChange={(value) => update(slice.id, 'departureStation', value)}
              />
              <div className='tooltip'>
                <i className="switch spread fa fa-fw fa-xl fa-exchange-alt" onClick={() => switchDirection(slice.id)}></i>
                <span className="bottom-tooltip-text">عكس الإتجاه</span>
              </div>
              <AirportPicker
                value={slice.destinationStation}
                airports={airports}
                placeholder="اختر وجهتك"
                onChange={(value) => update(slice.id, 'destinationStation', value)}
              />

              <div style={{ marginRight: '8px' }} className='custom-mobile multicity-datepicker'>
                {/* <DatePicker
                label="المغادرة"
                selected={slice.departureDate}
                min={format(addDays(NOW, 0), 'yyyy-MM-dd')}
                onChange={({ target: { value } }) => update(slice.id, 'departureDate', value)}
                streched={slice.departureStation && slice.destinationStation}
              /> */}
                <DatePicker
                  selected={slice.departureDate}
                  onChange={(value) => update(slice.id, 'departureDate', value)}
                  placeholderText={TODAYSTRING}
                  minDate={TODAY}
                  dateFormat="yyyy-MM-dd"
                  isClearable
                />
              </div>
              <i className="fas fa-fw fa-minus-circle remove-trip" onClick={() => removeSlice(slice.id)} />
            </div >
          );
        }
        )
      }
      {slices.length !== 9 && <button onClick={addSlice} className='blank-button' style={{ alignSelf: 'flex-start' }}>إضافة رحلة</button>}

    </>
  );
};

export default MulticitySelector;